import { ClaraConversationObject } from '@/modules/ai/models/ClaraConversationObject';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { Route } from '@/modules/core/app/constants/api.constants';
import { BaseResource } from '@/modules/core/app/resources/BaseResource';

export class ClaraResource extends BaseResource {
  async submitMessageFeedback(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_MESSAGE_FEEDBACK, params);
  }

  async submitConversationFeedback(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_CONVERSATION_FEEDBACK, params);
  }

  async addMessageToLibrary(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_MESSAGE_ADDTOLIBRARY, params);
  }

  async getConversations(): Promise<Partial<ClaraConversationObject>[]> {
    return this.getData(Route.AI_CLARA_CONVERSATIONS);
  }

  async cancelQuestion(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_CANCELQUESTION, params);
  }

  async pinConversation(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_CONVERSATION_PIN, params);
  }

  async updateConversationTitle(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_CONVERSATION_UPDATETITLE, params);
  }

  async requestSupportTicket(params: Params = {}): Promise<void> {
    return this.postData(Route.AI_CLARA_SUPPORTTICKET, params);
  }

  async getStreamUrl(params: Params = {}): Promise<Record<string, string>> {
    return this.postData(Route.AI_CLARA_STREAM_QUESTION, params);
  }

  async setHasViewedClaraSplashScreen(): Promise<void> {
    return this.postData(Route.AI_RAG_HASVIEWEDCLARA, {});
  }

  async setHasViewedClaraForPlannersLauncher(): Promise<void> {
    return this.postData(Route.AI_RAG_HASVIEWEDFORPLANNERSLAUNCHER, {});
  }

  async sendDraft(params: Params = {}): Promise<Partial<Message>> {
    return this.postData(Route.INBOX_CLARADRAFTS_SEND, params);
  }

  async discardDraft(params: Params = {}): Promise<void> {
    return this.postData(Route.INBOX_CLARADRAFTS_DISCARD, params);
  }
}

export default new ClaraResource();
